import React, { useState } from 'react';
import './GradeAdjuster.css';
import "../../../common/common_styles.css"

const GradeAdjuster = ({ initialGrade, gradeLabels, onChange, addSliderMargin }) => {
  const [sliderValue, setSliderValue] = useState(initialGrade);
  const labels_class = (addSliderMargin) ? "slider-labels-margin" : "slider-labels";

  const handleSliderChange = (event) => {
    setSliderValue(event.target.value);
    onChange(event.target.value);
  };

  return (
    <div className="full-width">
      <div id="slider-container">
        <input
          type="range"
          id="grade-slider"
          min="50"
          max="100"
          step="1"
          value={sliderValue}
          onChange={handleSliderChange}
        />
        <div className={labels_class}>
          {gradeLabels.map((label, index) => (
            <span key={index}>{label}</span>
          ))}
        </div>
        
      </div>
    </div>
  );
};

export default GradeAdjuster;